module.exports = __webpack_public_path__ + "img/吐.4d653170.png";